/**
 * CM module route definitions.
 *
 * Sprint CM-17-W2 retired the SiteList / SiteWorkspace / TemplateGallery /
 * SearchResults / PageList pages — page management is now driven by the
 * PageSettingsModal opened from the sidebar gear icon. Only PageEditor
 * + PageView remain as per-page surfaces.
 *
 * Cross-References:
 *   - sprint-cm-17-w2-gear-modal.md TKT-CM17W2-2
 *   - ADR-021: Content Management Architecture
 */
import { lazy } from 'react';

const PageEditor = lazy(() => import('./pages/PageEditor'));
const PageView = lazy(() => import('./pages/PageView'));

export const slug = 'cm';

export const routes = [
  { path: 'pages/new', element: PageEditor },
  { path: 'pages/:id/edit', element: PageEditor },
  { path: 'pages/:id', element: PageView },
  // Sprint CM-4 TKT-CM4-4 — UUID fallback (share-during-draft) and
  // slug-based addressable URLs. PageView component branches on
  // useParams to decide which API to call.
  { path: 'p/:id', element: PageView },
  // Catch-all for `/cm/<sectionPath>/<pageSlug>` — must be last so the
  // static routes above match first.
  { path: ':sectionPath/*', element: PageView },
];
